/**
 * Chart theme bridge — reads the ito design tokens from the document so
 * lightweight-charts renders in the active theme. Re-read on every
 * `data-theme` flip (see `<PriceChart>`'s MutationObserver).
 */

export interface ChartThemeColors {
  background: string;
  foreground: string;
  mutedForeground: string;
  grid: string;
  crosshair: string;
  border: string;
  text: string;
  up: string;
  down: string;
  upArea: string;
  downArea: string;
  series: [string, string, string, string, string, string];
}

/** Read the chart-relevant tokens from the active theme. */
export function readChartTheme(): ChartThemeColors {
  const cs = getComputedStyle(document.documentElement);
  const v = (name: string, fallback: string): string =>
    cs.getPropertyValue(name).trim() || fallback;
  return {
    background: v("--background", "#070605"),
    foreground: v("--foreground", "#f3f2ef"),
    mutedForeground: v("--muted-foreground", "#95928a"),
    grid: v("--chart-grid", "#181715"),
    crosshair: v("--chart-crosshair", "#504d45"),
    border: v("--chart-border", "#21201f"),
    text: v("--chart-text", "#95928a"),
    up: v("--chart-up", "#5b8a6b"),
    down: v("--chart-down", "#a85d45"),
    upArea: v("--chart-up-area", "rgb(91 138 107 / 0.18)"),
    downArea: v("--chart-down-area", "rgb(168 93 69 / 0.18)"),
    series: [
      v("--viz-series-1", "#0072b2"),
      v("--viz-series-2", "#e69f00"),
      v("--viz-series-3", "#009e73"),
      v("--viz-series-4", "#cc79a7"),
      v("--viz-series-5", "#56b4e9"),
      v("--viz-series-6", "#b8b6a9"),
    ],
  };
}
